import React, { useState } from "react";
import { connect } from "react-redux";
import {
  Button,
  Switch,
} from "@mui/material";

import { Row, Col, FormGroup, Alert, Label } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";

import TextField from "@mui/material/TextField";

import { updateOrgAccount } from "../../../store/actions";
import { convertToUTCDateFromMilliseconds } from "./../../../utilities/dateConversion";
import spinner from "../../../assets/images/loadingGif.gif";

import { makeStyles } from "@mui/styles";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: '8px',
    maxHeight: '90vh',
    overflow: 'auto',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%'
  }
}));

const UpdateOrganizationAccount = (props) => {
  console.log("UpdateOrganizationAccount props: ", props)
  const classes = useStyles();
  const { 
    open,
    onClose,
    licenses,
    customLicenses,
    orgAccountCode,
    account,
    resourceGroups
  } = props;
  

  const [subscription, setSubscription] = useState(account?.subscription?.name || null);
  const [subscriptionExpirationDate, setSubscriptionExpirationDate] = useState(account?.expiration_date || null);
  // const [accountResourceGroup, setAccountResourceGroup] = useState(account?.accountResourceGroups[0]?.resourcename);
  const [subscriptionType, setSubscriptionType] = useState(account?.subscription_type || "ASSISTED TRIAL");
  const [scanFrequency, setScanFrequency] = useState(account?.scan_frequency);
  const [contractAmount, setContractAmount] = useState(account?.contract_amount);
  const [thresholdAmount, setThresholdAmount] = useState(account?.threshold_amount);
  const [usagePercentage, setUsagePercentage] = useState(account?.usage_percentage);
  const [isLocked, setIsLocked] = useState(account?.islocked || false);
  const [resourceGroup, setResourceGroup] = useState(account?.accountResourceGroups[0]?.resourcename);
  const [offerId, setOfferId] = useState(account?.marketplaceDetails?.offerId || "");
  const [agreementId, setAgreementId] = useState(account?.marketplaceDetails?.agreementId || "" );
  const [paymentTerm, setPaymentTerm] = useState(account?.payment_term || "N/A");
  const [wafrWorkloadLimit, setWafrWorkloadLimit] = useState(account?.wafr_workload_limit || "");

  const handleSubscriptionInputChange = (e) => setSubscription(e.target.value);

  const isUpdateOrgAccountFormInvalid = () => { 
    const isInvalidItems = [
      {
        field: "contractAmount",
        isInvalid: contractAmount === "" ? true : false,
      },
      {
        field: "thresholdAmount",
        isInvalid: thresholdAmount === "" ? true : false,
      },
      {
        field: "usagePercentage",
        isInvalid: usagePercentage === "" ? true : false,
      },
      {
        field: "offerId",
        isInvalid: offerId === "" ? true : false,
      },
      {
        field: "agreementId",
        isInvalid: agreementId === "" ? true : false,
      },
      {
        field: "wafrWorkloadLimit",
        isInvalid: wafrWorkloadLimit === "" ? true : false,
      },
    ];

    return isInvalidItems?.filter((item) => item.isInvalid)?.length > 0;
  }

  const handleUpdateSubscription = (e) => {
    const browserDate = new Date(subscriptionExpirationDate);
    const utcDateAsMilliseconds = convertToUTCDateFromMilliseconds(browserDate.getTime());

    const complianceAddOns = account?.complianceAddOns.map((addOn) => ({
      name: addOn.name,
      enabled: addOn.enabled,
    }));

    const addOns = account?.subscription?.addons.map((addOn) => ({
      name: addOn.name,
      enabled: addOn.enabled,
      curEstimatesNumDays: addOn?.curEstimatesNumDays,
    }));


    const updateOrgAccountPayload = {
      acccode: orgAccountCode,
      subscription,
      expiration_date: utcDateAsMilliseconds,
      complianceAddOns,
      addOns,
      subscription_type: subscriptionType,
      resourceGroupRequestDTOS: resourceGroup,
      marketplaceDetailsDTO: {
        offerId: offerId,
        agreementId: agreementId
      },
      scan_frequency: ""+scanFrequency,
      contract_amount: contractAmount,
      threshold_amount: thresholdAmount,
      usage_percentage: usagePercentage,
      islocked: isLocked,
      payment_term: paymentTerm,
      wafr_workload_limit: wafrWorkloadLimit,
      costInsightStatus: account?.costInsightStatus !== undefined ? account.costInsightStatus : true,
      costOptimizationStatus: account?.costOptimizationStatus !== undefined ? account.costOptimizationStatus : true,
      eventInsightStatus: account?.eventInsightStatus !== undefined ? account.eventInsightStatus : true,
    };
    console.log("updateOrgAccountPayload : ", updateOrgAccountPayload);


    props.updateOrgAccount(updateOrgAccountPayload);
  };

  return (
    <Modal 
      className={classes.modal} 
      open={open} 
      onClose={onClose}
    >
      <Box className={classes.paper} style={{ height: "600px" }}>
        <h3>Update Subscription</h3>
        {props.isUpdatingOrgAccount && (
          <div style={{ display: "flex", alignContent: "center", justifyContent: "center" }}>
            <img src={spinner} width="32px" alt="Spinner" />
          </div>
        )}
        {/* Error message */}
        {props.updateOrgAccountError && (
          <Alert className="mt-3 mb-0" color="danger">
            Error while updating organization account. {JSON.stringify(props.updateOrgAccountError?.message)}
          </Alert>
        )}
        <AvForm>
          <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            <Row>
              <Col lg="6">
                <FormGroup>
                  <Label for="subscription">License</Label>
                  <AvField
                    type="select"
                    name="subscription"
                    id="subscription"
                    onChange={handleSubscriptionInputChange}
                    value={subscription}
                  >
                    {licenses?.["Subscription Model"]?.map((license) => (
                      <option key={license.Name}>{license.Name}</option>
                    ))}
                    {customLicenses?.map((license) => (
                      <option key={license.Name}>{license.Name}</option>
                    ))}
                  </AvField>
                </FormGroup>
              </Col>
              <Col lg="6">
                <FormGroup>
                  <Label for="subscriptionExpirationDate">Expiration Date</Label>
                  <DatePicker
                    selected={subscriptionExpirationDate ? new Date(subscriptionExpirationDate) : null}
                    onChange={(date) => setSubscriptionExpirationDate(date)}
                    className="form-control"
                    dateFormat="MM/dd/yyyy"
                    minDate={new Date()}
                    placeholderText="Select expiration date"
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col lg="6">
                <FormGroup>
                  <Label for="resourceGroup">Account Resource Group</Label>
                  {/* <FormControl fullWidth> */}
                    <AvField
                      type="select"
                      name="resourceGroup"
                      id="resourceGroup"
                      onChange={(e) => setResourceGroup(e.target.value)}
                      value={resourceGroup}
                    >
                      {resourceGroups?.map(resourceGroup => (
                        <option key={resourceGroup.resourcename} value={resourceGroup.resourcename}>{resourceGroup.resourcename}</option>
                      ))}
                    </AvField>
                </FormGroup>
              </Col>
              <Col lg="6">
                <FormGroup>
                  <Label for="subscriptionType">Subscription Type</Label>
                  <AvField
                    type="select"
                    name="subscriptionType"
                    id="subscriptionType"
                    onChange={(e) => setSubscriptionType(e.target.value)}
                    value={subscriptionType}
                  >
                    {[
                        "ASSISTED TRIAL",
                        "ASSISTED PAID",
                        "AWS PAID PUBLIC",
                        "AWS PAID PRIVATE",
                        "AWS TRIAL",
                        "ASSISTED CUSTOM",
                      ].map((type) => (
                        <option key={type} value={type}>
                          {type}
                        </option>
                    ))}
                  </AvField>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col lg="6">
                <FormGroup>
                  <Label for="contractAmount">Contract Amount</Label>
                  <AvField
                    name="contractAmount"
                    value={contractAmount}
                    onChange={(e) => setContractAmount(e.target.value)}
                    type="number"
                    errorMessage="Enter Contract Amount"
                    validate={{
                      required: {value: true},
                    }}
                    id="contractAmount"
                    placeholder="Contract Amount"
                  />
                </FormGroup>
              </Col>
              <Col lg="6">
                <FormGroup>
                  <Label for="paymentTerm">Payment Term</Label>
                  <AvField
                    type="select"
                    name="paymentTerm"
                    id="paymentTerm"
                    onChange={(e) => setPaymentTerm(e.target.value)}
                    value={paymentTerm}
                  >
                    <option value="monthly">Monthly</option>
                    <option value="yearly">Yearly</option>
                  </AvField>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col lg="6">
                <FormGroup>
                  <Label for="thresholdAmount">Threshold Amount</Label>
                  <AvField
                    name="thresholdAmount"
                    value={thresholdAmount}
                    onChange={(e) => setThresholdAmount(e.target.value)}
                    type="number"
                    errorMessage="Enter Threshold Amount"
                    validate={{
                      required: {value: true},
                    }}
                    id="thresholdAmount"
                    placeholder="Threshold Amount"
                  />
                </FormGroup>
              </Col>
              <Col lg="6">
                <FormGroup>
                  <Label for="usagePercentage">Usage Percentage</Label>
                  <AvField
                    name="usagePercentage"
                    value={usagePercentage}
                    onChange={(e) => setUsagePercentage(e.target.value)}
                    type="number"
                    errorMessage="Enter Usage Percentage"
                    validate={{
                      required: {value: true},
                    }}
                    id="usagePercentage"
                    placeholder="Usage Percentage"
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col lg="6">
                <FormGroup>
                  <Label for="offerId">Offer Id</Label>
                  <AvField
                    name="offerId"
                    value={offerId}
                    onChange={(e) => setOfferId(e.target.value)}
                    type="text"
                    errorMessage="Enter Offer Id"
                    validate={{
                      required: {value: true},
                    }}
                    id="offerId"
                    placeholder="Offer Id"
                  />
                </FormGroup>
              </Col>
              <Col lg="6">
                <FormGroup>
                  <Label for="agreementId">Agreement Id</Label>
                  <AvField
                    name="agreementId"
                    value={agreementId}
                    onChange={(e) => setAgreementId(e.target.value)}
                    type="text"
                    errorMessage="Enter Agreement Id"
                    validate={{
                      required: {value: true},
                    }}
                    id="agreementId"
                    placeholder="Agreement Id"
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col lg="6">
                <FormGroup>
                  <Label for="wafrWorkloadLimit">WAFR Workload Limit</Label>
                  <AvField
                    name="wafrWorkloadLimit"
                    value={wafrWorkloadLimit}
                    onChange={(e) => setWafrWorkloadLimit(e.target.value)}
                    type="number"
                    errorMessage="Enter WAFR Workload Limit"
                    validate={{
                      required: {value: true},
                    }}
                    id="wafrWorkloadLimit"
                    placeholder="WAFR Workload Limit"
                  />
                </FormGroup>
              </Col>
              <Col lg="6">
                <FormGroup>
                  <Label for="accountLocked">Account Locked Status</Label>
                  <Switch
                    checked={isLocked}
                    onChange={(e) => setIsLocked(e.target.checked)}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Button
              color="primary"
              variant="contained"
              disabled={isUpdateOrgAccountFormInvalid() || props.isUpdatingOrgAccount}
              onClick={handleUpdateSubscription}
            >
              Update Subscription
            </Button>
          </div>
        </AvForm>
      </Box>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  const { isUpdatingOrgAccount, updateOrgAccountError } = state.orgAccount;
  const { isGettingLicense } = state.globalLicense;
  const { isGettingCustomLicense } = state.customLicense;
  return {
    isUpdatingOrgAccount,
    updateOrgAccountError,
    isGettingLicense,
    isGettingCustomLicense,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateOrgAccount: (orgAccountCode, subscription) => {
      dispatch(updateOrgAccount(orgAccountCode, subscription));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateOrganizationAccount);
